import { render } from "./obiettivo.vue?vue&type=template&id=14c1bf38&ts=true"
import script from "./obiettivo.vue?vue&type=script&lang=ts"
export * from "./obiettivo.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__